/**
 * mirror-quiz.js
 * Shopify Spejl Quiz — sender svar til n8n webhook og viser 3 produkt-anbefalinger.
 *
 * Forventet JSON FRA n8n:
 * {
 *   "products": [
 *     {
 *       "title": "Rundt spejl Ø70 cm",
 *       "price": "799 kr.",
 *       "description": "Minimalistisk design til badeværelse",
 *       "reason": "Matcher dit ønske om rundt spejl inden for budget",
 *       "url": "/products/rundt-spejl-70cm",
 *       "image": "https://cdn.shopify.com/..."
 *     }
 *   ]
 * }
 *
 * Forventet JSON sendt TIL n8n:
 * {
 *   "answers": { "rum": "Badeværelse", "stil": "...", "form": "Rundt", ... },
 *   "meta": { "shop": "din-butik.myshopify.com", "locale": "da", "timestamp": "..." }
 * }
 */

(function () {
  'use strict';

  // ─── Spørgsmål & svarmuligheder ───────────────────────────────────────────
  const QUESTIONS = [
    {
      key: 'rum',
      text: 'Hvilket rum skal spejlet hænge i?',
      hint: 'Vælg ét svar',
      options: ['Badeværelse', 'Entre / gang', 'Soveværelse', 'Stue / alrum'],
    },
    {
      key: 'stil',
      text: 'Hvilken stil passer til dit hjem?',
      hint: 'Vælg ét svar',
      options: [
        'Minimalistisk / nordisk',
        'Rustikt / naturligt',
        'Moderne / industrielt',
        'Klassisk / romantisk',
        'Ingen præference'
      ],
    },
    {
      key: 'form',
      text: 'Hvilken form foretrækker du?',
      hint: 'Vælg ét svar',
      options: ['Rundt', 'Ovalt', 'Rektangulært / Firkantet spejl', 'Organisk spejl','Ingen præference'],
    },
    {
      key: 'stoerrelse',
      text: 'Hvilket størrelse spejl ønsker du?',
      hint: 'Vælg ét svar',
      options: [
        'Lille', 
        'Mellemstor', 
        'Stor', 
        'Helfigur',
        'Ingen præference'],
    },
    {
      key: 'brug',
      text: 'Hvad er den primære brug?',
      hint: 'Vælg ét svar',
      options: [
        'Se hele kroppen',
        'Ansigt og makeup',
        'Lyse rummet op',
        'Dekoration / udsmykning',
      ],
    },
    {
      key: 'budget',
      text: 'Hvad er dit budget?',
      hint: 'Vælg ét svar',
      options: [
        'Under 2.000 kr.',
        '2.000–3.000 kr.',
        'Over 3.000 kr.',
        'Ingen præference'
      ],
    },
  ];

  // ─── State ─────────────────────────────────────────────────────────────────
  let currentStep = 0;
  let answers = {};

  // ─── DOM-referencer ────────────────────────────────────────────────────────
  const quizEl     = document.getElementById('mirror-quiz');
  const stepLabel  = document.getElementById('mq-step-label');
  const questionEl = document.getElementById('mq-question');
  const hintEl     = document.getElementById('mq-hint');
  const progressEl = document.getElementById('mq-progress');
  const optionsEl  = document.getElementById('mq-options');
  const navEl      = document.getElementById('mq-nav');
  const prevBtn    = document.getElementById('mq-prev-btn');
  const nextBtn    = document.getElementById('mq-next-btn');
  const resultEl   = document.getElementById('mq-result');
  const loadingEl  = document.getElementById('mq-loading');
  const errorEl    = document.getElementById('mq-error');
  const retryBtn   = document.getElementById('mq-retry-btn');
  const restartBtn = document.getElementById('mq-restart-btn');

  const WEBHOOK_URL = quizEl ? quizEl.dataset.webhook : '';

  // ─── Render step ───────────────────────────────────────────────────────────
  function renderStep() {
    const q = QUESTIONS[currentStep];
    const total = QUESTIONS.length;

    stepLabel.textContent = `step ${currentStep + 1}/${total}`;
    questionEl.textContent = q.text;
    hintEl.textContent = q.hint;

    // Progress dots
    progressEl.innerHTML = '';
    for (let i = 0; i < total; i++) {
      const dot = document.createElement('span');
      dot.className =
        'mq-dot' +
        (i < currentStep ? ' mq-dot--done' : '') +
        (i === currentStep ? ' mq-dot--active' : '');
      dot.setAttribute('aria-hidden', 'true');
      progressEl.appendChild(dot);
    }

    // Svarmuligheder
    optionsEl.innerHTML = '';
    q.options.forEach((opt) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'mq-option' + (answers[q.key] === opt ? ' mq-option--selected' : '');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', answers[q.key] === opt ? 'true' : 'false');
      btn.innerHTML = `
        <span class="mq-option__radio" aria-hidden="true">
          <span class="mq-option__dot"></span>
        </span>
        <span class="mq-option__text">${escapeHtml(opt)}</span>
      `;
      btn.addEventListener('click', () => selectOption(opt));
      optionsEl.appendChild(btn);
    });

    prevBtn.disabled = currentStep === 0;
    nextBtn.disabled = !answers[q.key];
    nextBtn.textContent = currentStep === total - 1 ? 'Se mine spejle →' : 'Next';
  }

  // ─── Vælg svar ─────────────────────────────────────────────────────────────
  function selectOption(value) {
    const q = QUESTIONS[currentStep];
    answers[q.key] = value;

    optionsEl.querySelectorAll('.mq-option').forEach((btn) => {
      const isSelected = btn.querySelector('.mq-option__text').textContent === value;
      btn.classList.toggle('mq-option--selected', isSelected);
      btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });

    nextBtn.disabled = false;
  }

  // ─── Navigation ────────────────────────────────────────────────────────────
  function goNext() {
    const q = QUESTIONS[currentStep];
    if (!answers[q.key]) return;

    if (currentStep < QUESTIONS.length - 1) {
      currentStep++;
      renderStep();
    } else {
      submitQuiz();
    }
  }

  function goPrev() {
    if (currentStep > 0) {
      currentStep--;
      renderStep();
    }
  }

  // ─── Send til n8n webhook ──────────────────────────────────────────────────
  async function submitQuiz() {
    showLoading(true);

    const payload = {
      answers,
      meta: {
        shop: window.Shopify ? window.Shopify.shop : window.location.hostname,
        locale: document.documentElement.lang || 'da',
        timestamp: new Date().toISOString(),
      },
    };

    try {
      const response = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        credentials: 'omit',
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      console.log('[Mirror Quiz] Response:', JSON.stringify(data));
      showLoading(false);
      showResult(data);
    } catch (err) {
      console.error('[Mirror Quiz] Webhook fejl:', err);
      showLoading(false);
      showError();
    }
  }

  // ─── Vis 3 resultater ──────────────────────────────────────────────────────
  function showResult(data) {
    // Skjul quiz-elementer
    optionsEl.setAttribute('hidden', '');
    navEl.setAttribute('hidden', '');
    progressEl.setAttribute('hidden', '');

    // Opdater venstre panel
    stepLabel.textContent = 'dine anbefalinger';
    questionEl.textContent = 'Vi har fundet 3 spejle til dig 🪞';
    hintEl.textContent = '';

    // Byg produktkort — understøtter både { products: [] } og { product: {} }
    const products = data.products
      ? data.products
      : data.product
        ? [data.product]
        : [];

    if (products.length === 0) {
      showError();
      return;
    }

    resultEl.innerHTML = '';

    // Overskrift
    const heading = document.createElement('p');
    heading.className = 'mq-result__label';
    heading.textContent = 'Udvalgt til dig';
    resultEl.appendChild(heading);

    // Produktkort
    const grid = document.createElement('div');
    grid.className = 'mq-result__grid';

    products.forEach((p, index) => {
      const card = document.createElement('div');
      card.className = 'mq-result__card';

      // Badge: "Bedste match" på første kort
      if (index === 0) {
        const badge = document.createElement('span');
        badge.className = 'mq-result__badge';
        badge.textContent = 'Bedste match';
        card.appendChild(badge);
      }

      // Billede
      if (p.image) {
        const imgWrap = document.createElement('div');
        imgWrap.className = 'mq-result__img-wrap';
        const img = document.createElement('img');
        img.src = p.image;
        img.alt = p.title || 'Anbefalet spejl';
        img.width = 120;
        img.height = 120;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
        card.appendChild(imgWrap);
      }

      // Info
      const info = document.createElement('div');
      info.className = 'mq-result__info';

      const title = document.createElement('p');
      title.className = 'mq-result__name';
      title.textContent = p.title || 'Spejl';
      info.appendChild(title);

      if (p.price) {
        const price = document.createElement('p');
        price.className = 'mq-result__price';
        price.textContent = p.price;
        info.appendChild(price);
      }

      if (p.reason) {
        const reason = document.createElement('p');
        reason.className = 'mq-result__reason';
        reason.textContent = p.reason;
        info.appendChild(reason);
      } else if (p.description) {
        const desc = document.createElement('p');
        desc.className = 'mq-result__reason';
        desc.textContent = p.description;
        info.appendChild(desc);
      }

      card.appendChild(info);

      // CTA-knap
      if (p.url) {
        const link = document.createElement('a');
        link.href = p.url;
        link.className = 'mq-btn mq-btn--cta';
        link.textContent = 'Se produkt';
        link.target = '_self';
        card.appendChild(link);
      }

      grid.appendChild(card);
    });

    resultEl.appendChild(grid);

    // Genstart-knap
    const restartWrapper = document.createElement('div');
    restartWrapper.className = 'mq-result__restart';
    const restartBtnNew = document.createElement('button');
    restartBtnNew.className = 'mq-btn mq-btn--ghost';
    restartBtnNew.textContent = 'Tag quizzen igen';
    restartBtnNew.addEventListener('click', restart);
    restartWrapper.appendChild(restartBtnNew);
    resultEl.appendChild(restartWrapper);

    resultEl.removeAttribute('hidden');
  }

  // ─── UI-hjælpefunktioner ───────────────────────────────────────────────────
  function showLoading(show) {
    if (show) {
      optionsEl.setAttribute('hidden', '');
      navEl.setAttribute('hidden', '');
      loadingEl.removeAttribute('hidden');
    } else {
      loadingEl.setAttribute('hidden', '');
      optionsEl.removeAttribute('hidden');
      navEl.removeAttribute('hidden');
    }
  }

  function showError() {
    optionsEl.setAttribute('hidden', '');
    navEl.setAttribute('hidden', '');
    errorEl.removeAttribute('hidden');
  }

  function restart() {
    currentStep = 0;
    answers = {};

    resultEl.setAttribute('hidden', '');
    resultEl.innerHTML = '';
    errorEl.setAttribute('hidden', '');
    optionsEl.removeAttribute('hidden');
    navEl.removeAttribute('hidden');
    progressEl.removeAttribute('hidden');

    renderStep();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ─── Event listeners ───────────────────────────────────────────────────────
  if (!quizEl) {
    console.warn('[Mirror Quiz] #mirror-quiz ikke fundet.');
    return;
  }

  nextBtn.addEventListener('click', goNext);
  prevBtn.addEventListener('click', goPrev);
  retryBtn.addEventListener('click', submitQuiz);
  restartBtn.addEventListener('click', restart);

  optionsEl.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const btn = e.target.closest('.mq-option');
      if (btn) btn.click();
    }
  });

  // ─── Init ──────────────────────────────────────────────────────────────────
  renderStep();
})();